<template>
    <div>
        <TeItiKahurangiFormComponent/>
    </div>
</template>

<script>

import TeItiKahurangiFormComponent from "@/components/DataComponents/Forms/TeItiKahurangiFormComponent.vue";

export default {
  name: "te-iti-kahurangi-view",
  components: { TeItiKahurangiFormComponent },
  title: 'TeItiKahurangiForm',
}
</script>
